import { UserNewPasswordModel } from './UserNewPasswordModel';

export class UserSetPasswordModel extends UserNewPasswordModel
{
      OldPassword :string;
}